simply.checkAvailCoffee = function(that,handle,main_par,other_active){
	if(cn(handle) && cn(other_active)){
		$(".coffee-types-block .coffee-block",main_par).removeClass("showhide");
	}else{
		$(".coffee-types-block .coffee-block",main_par).each(function(i,e){
			var avail_items = $(e).find(".hidden-handle").text();
			var make_hide = true;
			if(!cn(handle) && cn(other_active)){
				if(avail_items.includes(handle)){
					make_hide = false;
				}
			}else if(cn(handle) && !cn(other_active)){
				if($(e).attr("data-handle") == other_active){
					make_hide = false;
				}
			}else if(!cn(handle) && !cn(other_active)){
				if($(e).attr("data-handle") == other_active && avail_items.includes(handle)){
					make_hide = false;
				}
			}
			if(make_hide){
				$(e).addClass("showhide");
			}else{
				$(e).removeClass("showhide");
			}
		});
	}
	var block_len = $(".coffee-types-block .coffee-block",main_par).length;
	for (var i=block_len;i>=1;i--){
		var find_item = $(".coffee-types-block .coffee-block[data-index="+i+"]",main_par);
		if(find_item.length > 0){
			if(!find_item.hasClass("showhide")){
				$(".coffee-types-block",main_par).prepend(find_item);
			}
		}
	}
	if(screen.width < 1025){
		$(".coffee-submenu,.coffee-menu-main",main_par).slideUp("fast");
		var ul_par = $(that).closest(".menu-wrap");
		var curr_text = $(that).find(".blend-text").text();
		$(".mob-text .mob-text-val",ul_par).text(curr_text);
	}
	simply.coffeePageProdHeight();
	$('html, body').animate({
  	scrollTop: $(that).closest(".shopify-section").find(".coffee-types-block").offset().top 
  }, 1000);
};
simply.toggleActive = function(that){
	var is_active = $(that).hasClass("active");
	if(!is_active){
		$(that).siblings().removeClass("active");
		$(that).addClass("active");
	}
};
simply.coffeePageProdHeight = function(){
  var coffee_page_blocks = ".coffee-types-block .coffee-block";
  if(coffee_page_blocks.length > 0){
    $(coffee_page_blocks).each(function(index,e){
      var coffees_page_item_par = $(".coffee-type-prod-wrap .type-title",$(e));
      var coffees_page_item_child = $(".coffee-type-prod-wrap .type-title span",$(e));
      simply.miniHeight(coffees_page_item_par,coffees_page_item_child);
    });
  }
};
simply.coffeeClick = function(){
	$(".coffee-menus .coffee-sub-link").click(function(){
		simply.toggleActive(this);
		var data_handle = $(this).attr("data-handle");
		var main_par = $(this).closest(".coffee-types-wrapper");
		var parent_active = $(".coffee-menu-main .coffee-main-link.active",main_par).attr("data-handle");
		simply.checkAvailCoffee(this,parent_active,main_par,data_handle);
	});
	$(".coffee-menus .coffee-main-link").click(function(){
		simply.toggleActive(this);
		var data_handle = $(this).attr("data-handle");
		var main_par = $(this).closest(".coffee-types-wrapper");
		$(".coffee-submenu .coffee-sub-link",main_par).removeClass("active").first().addClass("active");
		var child_ul = $(".coffee-submenu .coffee-sub-link.active",main_par);
		var child_active = child_ul.attr("data-handle");
		$(".coffee-submenu .sublink",main_par).removeClass("showhide");
		if(!cn(data_handle)){
			$(".coffee-submenu .sublink",main_par).each(function(i,e){
				var avail_items = $(this).find(".hidden-handle").text();
				if(avail_items.includes(data_handle)){
					$(e).removeClass("showhide");
				}else{
					$(e).addClass("showhide");
				}
			});
		}
		$(".coffee-submenu-wrap .mob-text-val",main_par).text(child_ul.find(".blend-text").text());
		simply.checkAvailCoffee(this,data_handle,main_par,child_active);
	});
	$(".coffee-menus .mob-text").click(function(e){
		e.stopPropagation();
		var main_par = $(this).closest(".coffee-menus");
		var curr_url = $(this).parent().find("ul");
		$(".coffee-submenu,.coffee-menu-main",main_par).not(curr_url).hide();
		setTimeout(function(){
			curr_url.stop().slideToggle();
		},100);
	});
	$(document).click(function(){
		if(screen.width < 1025){
			if($(".menu-wrap ul").is(":visible")){
		  	$(".menu-wrap ul").slideUp();
		  }
		}
	});
	$(window).resize(function(){
		$(".coffee-submenu,.coffee-menu-main",$(".coffee-menus")).hide();
		if(screen.width > 1024){
			$(".coffee-submenu,.coffee-menu-main",$(".coffee-menus")).show();
		}
		simply.coffeePageProdHeight();
	});
};
simply.coffeeSlider = function(){
	var image_group = $(".coffee-types-block .coffee-block .main-img");
	$(image_group).each(function(i,e){
		if($(".img",$(e)).length > 1){
			 $(e).slick({
	      dots: false,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      cssEase: 'linear',
	    });
		}
	});
};
$(document).ready(function() {
	simply.coffeeSlider()
	simply.coffeeClick();
	$(window).on('load', function(e){
		simply.coffeePageProdHeight();
	});
});
